module.exports = require("electron-serve");